// Bank Action Type

// Bank List
export const BANK_LIST_REQUEST = "BANK_LIST_REQUEST";
export const BANK_LIST_SUCCESS = "BANK_LIST_SUCCESS";
export const BANK_LIST_FAIL = "BANK_LIST_FAIL";

// Single Bank Transaction List
export const BANK_TRANSACTION_LIST_REQUEST = "BANK_TRANSACTION_LIST_REQUEST";
export const BANK_TRANSACTION_LIST_SUCCESS = "BANK_TRANSACTION_LIST_SUCCESS";
export const BANK_TRANSACTION_LIST_FAIL = "BANK_TRANSACTION_LIST_FAIL";

// All Banks Transaction List
export const BANK_ALL_TRANSACTION_LIST_REQUEST =
  "BANK_ALL_TRANSACTION_LIST_REQUEST";
export const BANK_ALL_TRANSACTION_LIST_SUCCESS =
  "BANK_ALL_TRANSACTION_LIST_SUCCESS";
export const BANK_ALL_TRANSACTION_LIST_FAIL = "BANK_ALL_TRANSACTION_LIST_FAIL";

// UnAllocated Bank Transactions List
export const BANK_UNALLOCATED_TRANSACTION_LIST_REQUEST =
  "BANK_UNALLOCATED_TRANSACTION_LIST_REQUEST";
export const BANK_UNALLOCATED_TRANSACTION_LIST_SUCCESS =
  "BANK_UNALLOCATED_TRANSACTION_LIST_SUCCESS";
export const BANK_UNALLOCATED_TRANSACTION_LIST_FAIL =
  "BANK_UNALLOCATED_TRANSACTION_LIST_FAIL";

// Item Allocation List
export const ITEM_ALLOCATION_LIST_REQUEST = "ITEM_ALLOCATION_LIST_REQUEST";
export const ITEM_ALLOCATION_LIST_SUCCESS = "ITEM_ALLOCATION_LIST_SUCCESS";
export const ITEM_ALLOCATION_LIST_FAIL = "ITEM_ALLOCATION_LIST_FAIL";

// Clear Allocated Transaction and items request
export const CLEAR_ALLOCATED_TRANSACTION_AND_ITEMS_REQUEST =
  "CLEAR_ALLOCATED_TRANSACTION_AND_ITEMS_REQUEST";
export const CLEAR_ALLOCATED_TRANSACTION_AND_ITEMS_SUCCESS =
  "CLEAR_ALLOCATED_TRANSACTION_AND_ITEMS_SUCCESS";
export const CLEAR_ALLOCATED_TRANSACTION_AND_ITEMS_FAIL =
  "CLEAR_ALLOCATED_TRANSACTION_AND_ITEMS_FAIL";

// Unclear transaction request
export const UNCLEAR_TRANSACTION_REQUEST = "UNCLEAR_TRANSACTION_REQUEST";
export const UNCLEAR_TRANSACTION_SUCCESS = "UNCLEAR_TRANSACTION_SUCCESS";
export const UNCLEAR_TRANSACTION_FAIL = "UNCLEAR_TRANSACTION_FAIL";

// Single Customer Search all transactions request
export const CUSTOMER_SEARCH_ALL_TRANSACTIONS_REQUEST =
  "CUSTOMER_SEARCH_ALL_TRANSACTIONS_REQUEST";
export const CUSTOMER_SEARCH_ALL_TRANSACTIONS_SUCCESS =
  "CUSTOMER_SEARCH_ALL_TRANSACTIONS_SUCCESS";
export const CUSTOMER_SEARCH_ALL_TRANSACTIONS_FAIL =
  "CUSTOMER_SEARCH_ALL_TRANSACTIONS_FAIL";

// Single Supplier Search all transactions request
export const SUPPLIER_SEARCH_ALL_TRANSACTIONS_REQUEST =
  "SUPPLIER_SEARCH_ALL_TRANSACTIONS_REQUEST";
export const SUPPLIER_SEARCH_ALL_TRANSACTIONS_SUCCESS =
  "SUPPLIER_SEARCH_ALL_TRANSACTIONS_SUCCESS";
export const SUPPLIER_SEARCH_ALL_TRANSACTIONS_FAIL =
  "SUPPLIER_SEARCH_ALL_TRANSACTIONS_FAIL";

// Create Single Bank Transaction
export const CREATE_SINGLE_BANK_TRANSACTION_REQUEST =
  "CREATE_SINGLE_BANK_TRANSACTION_REQUEST";
export const CREATE_SINGLE_BANK_TRANSACTION_SUCCESS =
  "CREATE_SINGLE_BANK_TRANSACTION_SUCCESS";
export const CREATE_SINGLE_BANK_TRANSACTION_FAIL =
  "CREATE_SINGLE_BANK_TRANSACTION_FAIL";

// Bank Single Customer Transaction PDF Statement Request
export const BANK_SINGLE_CUSTOMER_TRANSACTION_PDF_STATEMENT_REQUEST =
  "BANK_SINGLE_CUSTOMER_TRANSACTION_PDF_STATEMENT_REQUEST";
export const BANK_SINGLE_CUSTOMER_TRANSACTION_PDF_STATEMENT_SUCCESS =
  "BANK_SINGLE_CUSTOMER_TRANSACTION_PDF_STATEMENT_SUCCESS";
export const BANK_SINGLE_CUSTOMER_TRANSACTION_PDF_STATEMENT_FAIL =
  "BANK_SINGLE_CUSTOMER_TRANSACTION_PDF_STATEMENT_FAIL";

// Bank upload transactions request
export const BANK_UPLOAD_TRANSACTIONS_REQUEST =
  "BANK_UPLOAD_TRANSACTIONS_REQUEST";
export const BANK_UPLOAD_TRANSACTIONS_SUCCESS =
  "BANK_UPLOAD_TRANSACTIONS_SUCCESS";
export const BANK_UPLOAD_TRANSACTIONS_FAIL = "BANK_UPLOAD_TRANSACTIONS_FAIL";

// Assigned Only Bank Transaction List
export const BANK_ASSIGNED_ONLY_TRANSACTION_LIST_REQUEST =
  "BANK_ASSIGNED_ONLY_TRANSACTION_LIST_REQUEST";
export const BANK_ASSIGNED_ONLY_TRANSACTION_LIST_SUCCESS =
  "BANK_ASSIGNED_ONLY_TRANSACTION_LIST_SUCCESS";
export const BANK_ASSIGNED_ONLY_TRANSACTION_LIST_FAIL =
  "BANK_ASSIGNED_ONLY_TRANSACTION_LIST_FAIL";

// Bank assign transaction to customer
export const BANK_ASSIGN_TRANSACTION_TO_CUSTOMER_REQUEST =
  "BANK_ASSIGN_TRANSACTION_TO_CUSTOMER_REQUEST";
export const BANK_ASSIGN_TRANSACTION_TO_CUSTOMER_SUCCESS =
  "BANK_ASSIGN_TRANSACTION_TO_CUSTOMER_SUCCESS";
export const BANK_ASSIGN_TRANSACTION_TO_CUSTOMER_FAIL =
  "BANK_ASSIGN_TRANSACTION_TO_CUSTOMER_FAIL";

// Bank Unassign transaction from customer
export const BANK_UNASSIGN_TRANSACTION_FROM_CUSTOMER_REQUEST =
  "BANK_UNASSIGN_TRANSACTION_FROM_CUSTOMER_REQUEST";
export const BANK_UNASSIGN_TRANSACTION_FROM_CUSTOMER_SUCCESS =
  "BANK_UNASSIGN_TRANSACTION_FROM_CUSTOMER_SUCCESS";
export const BANK_UNASSIGN_TRANSACTION_FROM_CUSTOMER_FAIL =
  "BANK_UNASSIGN_TRANSACTION_FROM_CUSTOMER_FAIL";

// Create Bank
export const CREATE_BANK = "CREATE_BANK";
export const CREATE_BANK_SUCCESS = "CREATE_BANK_SUCCESS";
export const CREATE_BANK_FAIL = "CREATE_BANK_FAIL";

// Update Bank
export const UPDATE_BANK = "UPDATE_BANK";
export const UPDATE_BANK_SUCCESS = "UPDATE_BANK_SUCCESS";
export const UPDATE_BANK_FAIL = "UPDATE_BANK_FAIL";

// Delete Bank
export const DELETE_BANK = "DELETE_BANK";
export const DELETE_BANK_SUCCESS = "DELETE_BANK_SUCCESS";
export const DELETE_BANK_FAIL = "DELETE_BANK_FAIL";

// Sync transactions from the bank (open banking feed) for one bank account.
export const SYNC_BANK_TRANSACTIONS = "SYNC_BANK_TRANSACTIONS";
export const SYNC_BANK_TRANSACTIONS_SUCCESS = "SYNC_BANK_TRANSACTIONS_SUCCESS";
export const SYNC_BANK_TRANSACTIONS_FAIL = "SYNC_BANK_TRANSACTIONS_FAIL";
export const SYNC_BANK_TRANSACTIONS_RESET = "SYNC_BANK_TRANSACTIONS_RESET";

// Single Customer Transaction Open Items PDF Statement
export const SINGLE_CUSTOMER_TRANSACTION_OPEN_ITEMS_PDF_STATEMENT_REQUEST =
  "SINGLE_CUSTOMER_TRANSACTION_OPEN_ITEMS_PDF_STATEMENT_REQUEST";
export const SINGLE_CUSTOMER_TRANSACTION_OPEN_ITEMS_PDF_STATEMENT_SUCCESS =
  "SINGLE_CUSTOMER_TRANSACTION_OPEN_ITEMS_PDF_STATEMENT_SUCCESS";
export const SINGLE_CUSTOMER_TRANSACTION_OPEN_ITEMS_PDF_STATEMENT_FAIL =
  "SINGLE_CUSTOMER_TRANSACTION_OPEN_ITEMS_PDF_STATEMENT_FAIL";

//  Single Customer Transaction All Items PDF Statement
export const SINGLE_CUSTOMER_TRANSACTION_ALL_ITEMS_PDF_STATEMENT_REQUEST =
  "SINGLE_CUSTOMER_TRANSACTION_ALL_ITEMS_PDF_STATEMENT_REQUEST";
export const SINGLE_CUSTOMER_TRANSACTION_ALL_ITEMS_PDF_STATEMENT_SUCCESS =
  "SINGLE_CUSTOMER_TRANSACTION_ALL_ITEMS_PDF_STATEMENT_SUCCESS";
export const SINGLE_CUSTOMER_TRANSACTION_ALL_ITEMS_PDF_STATEMENT_FAIL =
  "SINGLE_CUSTOMER_TRANSACTION_ALL_ITEMS_PDF_STATEMENT_FAIL";

// Bank Transaction Allocation Delete Transaction
export const BANK_TRANSACTION_ALLOCATION_DELETE_TRANSACTION_REQUEST =
  "BANK_TRANSACTION_ALLOCATION_DELETE_TRANSACTION_REQUEST";
export const BANK_TRANSACTION_ALLOCATION_DELETE_TRANSACTION_SUCCESS =
  "BANK_TRANSACTION_ALLOCATION_DELETE_TRANSACTION_SUCCESS";
export const BANK_TRANSACTION_ALLOCATION_DELETE_TRANSACTION_FAIL =
  "BANK_TRANSACTION_ALLOCATION_DELETE_TRANSACTION_FAIL";

// Get Manual Bank Transaction Details
export const GET_MANUAL_BANK_TRANSACTION_DETAILS_REQUEST =
  "GET_MANUAL_BANK_TRANSACTION_DETAILS_REQUEST";
export const GET_MANUAL_BANK_TRANSACTION_DETAILS_SUCCESS =
  "GET_MANUAL_BANK_TRANSACTION_DETAILS_SUCCESS";
export const GET_MANUAL_BANK_TRANSACTION_DETAILS_FAIL =
  "GET_MANUAL_BANK_TRANSACTION_DETAILS_FAIL";

// Update Manual Bank Transaction Details
export const UPDATE_MANUAL_BANK_TRANSACTION_DETAILS_REQUEST =
  "UPDATE_MANUAL_BANK_TRANSACTION_DETAILS_REQUEST";
export const UPDATE_MANUAL_BANK_TRANSACTION_DETAILS_SUCCESS =
  "UPDATE_MANUAL_BANK_TRANSACTION_DETAILS_SUCCESS";
export const UPDATE_MANUAL_BANK_TRANSACTION_DETAILS_FAIL =
  "UPDATE_MANUAL_BANK_TRANSACTION_DETAILS_FAIL";

//Bank Account Provider List
export const BANK_ACCOUNT_PROVIDER_LIST_REQUEST =
  "BANK_ACCOUNT_PROVIDER_LIST_REQUEST";
export const BANK_ACCOUNT_PROVIDER_LIST_SUCCESS =
  "BANK_ACCOUNT_PROVIDER_LIST_SUCCESS";
export const BANK_ACCOUNT_PROVIDER_LIST_FAIL =
  "BANK_ACCOUNT_PROVIDER_LIST_FAIL";

//Get Bank account status list
export const GET_BANK_ACCOUNT_STATUS_LIST = "GET_BANK_ACCOUNT_STATUS_LIST";
export const GET_BANK_ACCOUNT_STATUS_LIST_SUCCESS =
  "GET_BANK_ACCOUNT_STATUS_LIST_SUCCESS";
export const GET_BANK_ACCOUNT_STATUS_LIST_FAIL =
  "GET_BANK_ACCOUNT_STATUS_LIST_FAILURE";
// Get Bank Account Status Data
export const GET_BANK_ACCOUNT_STATUS_DATA_REQUEST =
  "GET_BANK_ACCOUNT_STATUS_DATA_REQUEST";
export const GET_BANK_ACCOUNT_STATUS_DATA_SUCCESS =
  "GET_BANK_ACCOUNT_STATUS_DATA_SUCCESS";
export const GET_BANK_ACCOUNT_STATUS_DATA_FAIL =
  "GET_BANK_ACCOUNT_STATUS_DATA_FAIL";

// Create Bank Account Status
export const CREATE_BANK_ACCOUNT_STATUS_REQUEST =
  "CREATE_BANK_ACCOUNT_STATUS_REQUEST";
export const CREATE_BANK_ACCOUNT_STATUS_SUCCESS =
  "CREATE_BANK_ACCOUNT_STATUS_SUCCESS";
export const CREATE_BANK_ACCOUNT_STATUS_FAIL =
  "CREATE_BANK_ACCOUNT_STATUS_FAIL";

// Update Bank Account Status
export const UPDATE_BANK_ACCOUNT_STATUS_REQUEST =
  "UPDATE_BANK_ACCOUNT_STATUS_REQUEST";
export const UPDATE_BANK_ACCOUNT_STATUS_SUCCESS =
  "UPDATE_BANK_ACCOUNT_STATUS_SUCCESS";
export const UPDATE_BANK_ACCOUNT_STATUS_FAIL =
  "UPDATE_BANK_ACCOUNT_STATUS_FAIL";

// Delete Bank Account Status
export const DELETE_BANK_ACCOUNT_STATUS_REQUEST =
  "DELETE_BANK_ACCOUNT_STATUS_REQUEST";
export const DELETE_BANK_ACCOUNT_STATUS_SUCCESS =
  "DELETE_BANK_ACCOUNT_STATUS_SUCCESS";
export const DELETE_BANK_ACCOUNT_STATUS_FAIL =
  "DELETE_BANK_ACCOUNT_STATUS_FAIL";

// bank account feed connection request
export const BANK_ACCOUNT_FEED_CONNECTION_REQUEST =
  "BANK_ACCOUNT_FEED_CONNECTION_REQUEST";
export const BANK_ACCOUNT_FEED_CONNECTION_SUCCESS =
  "BANK_ACCOUNT_FEED_CONNECTION_SUCCESS";
export const BANK_ACCOUNT_FEED_CONNECTION_FAIL =
  "BANK_ACCOUNT_FEED_CONNECTION_FAIL";
///bankaccountfeed/mapaccounts
export const BANK_ACCOUNT_FEED_MAP_ACCOUNTS_REQUEST =
  "BANK_ACCOUNT_FEED_MAP_ACCOUNTS_REQUEST";
export const BANK_ACCOUNT_FEED_MAP_ACCOUNTS_SUCCESS =
  "BANK_ACCOUNT_FEED_MAP_ACCOUNTS_SUCCESS";
export const BANK_ACCOUNT_FEED_MAP_ACCOUNTS_FAIL =
  "BANK_ACCOUNT_FEED_MAP_ACCOUNTS_FAIL";
///banktransaction/import
export const BANK_TRANSACTION_IMPORT_REQUEST =
  "BANK_TRANSACTION_IMPORT_REQUEST";
export const BANK_TRANSACTION_IMPORT_SUCCESS =
  "BANK_TRANSACTION_IMPORT_SUCCESS";
export const BANK_TRANSACTION_IMPORT_FAIL = "BANK_TRANSACTION_IMPORT_FAIL";

///banktransactionallocation/unclear
export const BANK_TRANSACTION_ALLOCATION_UNCLEAR_REQUEST =
  "BANK_TRANSACTION_ALLOCATION_UNCLEAR_REQUEST";
export const BANK_TRANSACTION_ALLOCATION_UNCLEAR_SUCCESS =
  "BANK_TRANSACTION_ALLOCATION_UNCLEAR_SUCCESS";
export const BANK_TRANSACTION_ALLOCATION_UNCLEAR_FAIL =
  "BANK_TRANSACTION_ALLOCATION_UNCLEAR_FAIL";

///banktransactionallocation/split
export const BANK_TRANSACTION_ALLOCATION_SPLIT_REQUEST =
  "BANK_TRANSACTION_ALLOCATION_SPLIT_REQUEST";
export const BANK_TRANSACTION_ALLOCATION_SPLIT_SUCCESS =
  "BANK_TRANSACTION_ALLOCATION_SPLIT_SUCCESS";
export const BANK_TRANSACTION_ALLOCATION_SPLIT_FAIL =
  "BANK_TRANSACTION_ALLOCATION_SPLIT_FAIL";

///bankaccountfeed/reconnectionrequest
export const BANK_ACCOUNT_FEED_RECONNECTION_REQUEST =
  "BANK_ACCOUNT_FEED_RECONNECTION_REQUEST";
export const BANK_ACCOUNT_FEED_RECONNECTION_SUCCESS =
  "BANK_ACCOUNT_FEED_RECONNECTION_SUCCESS";
export const BANK_ACCOUNT_FEED_RECONNECTION_FAIL =
  "BANK_ACCOUNT_FEED_RECONNECTION_FAIL";
///clearingdocument/search
export const CLEARING_DOCUMENT_SEARCH_REQUEST =
  "CLEARING_DOCUMENT_SEARCH_REQUEST";
export const CLEARING_DOCUMENT_SEARCH_SUCCESS =
  "CLEARING_DOCUMENT_SEARCH_SUCCESS";
export const CLEARING_DOCUMENT_SEARCH_FAIL = "CLEARING_DOCUMENT_SEARCH_FAIL";
///banktransactionallocation/autoclear
export const BANK_TRANSACTION_ALLOCATION_AUTOCLEAR_REQUEST =
  "BANK_TRANSACTION_ALLOCATION_AUTOCLEAR_REQUEST";
export const BANK_TRANSACTION_ALLOCATION_AUTOCLEAR_SUCCESS =
  "BANK_TRANSACTION_ALLOCATION_AUTOCLEAR_SUCCESS";
export const BANK_TRANSACTION_ALLOCATION_AUTOCLEAR_FAIL =
  "BANK_TRANSACTION_ALLOCATION_AUTOCLEAR_FAIL";

// Bank Account Attachment (bank statements) - scoped by bank account
export const BANK_ACCOUNT_ATTACHMENT_SEARCH = "BANK_ACCOUNT_ATTACHMENT_SEARCH";
export const BANK_ACCOUNT_ATTACHMENT_SEARCH_SUCCESS =
  "BANK_ACCOUNT_ATTACHMENT_SEARCH_SUCCESS";
export const BANK_ACCOUNT_ATTACHMENT_SEARCH_FAILURE =
  "BANK_ACCOUNT_ATTACHMENT_SEARCH_FAILURE";

export const BANK_ACCOUNT_ATTACHMENT_DELETE = "BANK_ACCOUNT_ATTACHMENT_DELETE";
export const BANK_ACCOUNT_ATTACHMENT_DELETE_SUCCESS =
  "BANK_ACCOUNT_ATTACHMENT_DELETE_SUCCESS";
export const BANK_ACCOUNT_ATTACHMENT_DELETE_FAILURE =
  "BANK_ACCOUNT_ATTACHMENT_DELETE_FAILURE";

// Bank Account Statement (bank statements with a period) - scoped by bank account
export const BANK_ACCOUNT_STATEMENT_SEARCH = "BANK_ACCOUNT_STATEMENT_SEARCH";
export const BANK_ACCOUNT_STATEMENT_SEARCH_SUCCESS =
  "BANK_ACCOUNT_STATEMENT_SEARCH_SUCCESS";
export const BANK_ACCOUNT_STATEMENT_SEARCH_FAILURE =
  "BANK_ACCOUNT_STATEMENT_SEARCH_FAILURE";

export const BANK_ACCOUNT_STATEMENT_DELETE = "BANK_ACCOUNT_STATEMENT_DELETE";
export const BANK_ACCOUNT_STATEMENT_DELETE_SUCCESS =
  "BANK_ACCOUNT_STATEMENT_DELETE_SUCCESS";
export const BANK_ACCOUNT_STATEMENT_DELETE_FAILURE =
  "BANK_ACCOUNT_STATEMENT_DELETE_FAILURE";
